import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=0b6a51da&scoped=true&"
import script from "./SendMessage.vue?vue&type=script&lang=ts&"
export * from "./SendMessage.vue?vue&type=script&lang=ts&"
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=0b6a51da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a51da",
  null
  
)

export default component.exports